module.exports = __webpack_public_path__ + "static/media/Croatia_Brazil.23d94e19.jpeg";